// extracted by mini-css-extract-plugin
export default {"news":"News_news__Ci96+"};